import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const path = window.location.pathname;
  const reqUrl = String(config.url || "");
  const superToken = localStorage.getItem("super_token");
  if (path.startsWith("/super") && superToken) {
    config.headers.Authorization = `Bearer ${superToken}`;
  } else {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  if (reqUrl.startsWith("/admin") || reqUrl.startsWith("/attendance")) {
    const branchId = localStorage.getItem("active_branch_id");
    if (branchId) {
      config.headers["X-Branch-Id"] = branchId;
    }
  }
  if (reqUrl.startsWith("/super")) {
    const superBranchId = localStorage.getItem("super_branch_id");
    if (superBranchId) {
      config.headers["X-Branch-Id"] = superBranchId;
    }
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/asistencia")) {
        window.location.href = "/admin/login";
      } else if (path.startsWith("/super") && path !== "/super/login") {
        localStorage.removeItem("super_token");
        window.location.href = "/super/login";
      } else if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem("token");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
